(function() {
	'use strict';
	angular.module('app.setup')
		.controller('projectSavingsCategoryForm', projectSavingsCategoryForm);

	projectSavingsCategoryForm.$inject = ['$scope', 'projectSavingsCategoryService', 'storeService'];
	function projectSavingsCategoryForm($scope, projectSavingsCategoryService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// view model functions
		vm.projectSavingCategory = $scope.projectSavingCategory;
		vm.customerNdx = $scope.customerNdx;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		vm.isLoadingUpdate = false;
		init();
		
		function init() {
			if (vm.action == 'Edit') {
				vm.originalProjectSavingCategory = jQuery.extend({}, vm.projectSavingCategory, true);
			} 
			else {
				vm.projectSavingCategory = {
					customerNdx: vm.customerNdx,
					savingType: 'Savings',
					includeInTotal: true
				};
			}
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			if (typeof vm.projectSavingCategory.id === 'undefined') {
				projectSavingsCategoryService.addProjectSavingsCategory(vm.projectSavingCategory).then(function(message) {
					$scope.result(message, message == 'Savings Category created successfully');
					vm.isSaveButtonDisabled = false;
				});
			} else {
				var lastModified = (typeof vm.projectSavingCategory.lastModified === 'undefined') ? (new Date()).toUTCString() : (new Date(vm.projectSavingCategory.lastModified)).toUTCString();
				if (vm.projectSavingCategory.name !== vm.originalProjectSavingCategory.name ||
					vm.projectSavingCategory.savingType !== vm.originalProjectSavingCategory.savingType ||
					vm.projectSavingCategory.includeInTotal !== vm.originalProjectSavingCategory.includeInTotal) {
					if (isFormChangedForLoadingUpdate()) {
						vm.isLoadingUpdate = true;
					}
					var projectSavingCategory = {
						id: vm.projectSavingCategory.id,
						name: vm.projectSavingCategory.name,
						savingType: vm.projectSavingCategory.savingType,
						includeInTotal: vm.projectSavingCategory.includeInTotal,
						customerNdx: vm.customerNdx
					};
					projectSavingsCategoryService.updateProjectSavingsCategory(projectSavingCategory, lastModified).then(function (message) {
						vm.isLoadingUpdate = false;
						if (_.isString(message)) {
							$scope.result(message, false);
						} else {
							$scope.result('Savings Category updated successfully', message.data.id == vm.projectSavingCategory.id);
						}
					});
				} else {
					$scope.result('', true);
				}
				vm.isSaveButtonDisabled = false;
			}
		}
		
		function close() {
			$scope.result('', false);
		}

		function isFormChangedForLoadingUpdate() {
			return vm.projectSavingCategory.savingType !== vm.originalProjectSavingCategory.savingType ||
				vm.projectSavingCategory.includeInTotal !== vm.originalProjectSavingCategory.includeInTotal;
		}
	}
})();
